import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const RadioField = ({
  containerClassName = '',
  className = '',
  inputClassName = '',
  meta = {},
  errorMessage = '',
  options = [],
  input = {},
  labelClassName,
  componentClassName,
  attributes = {}
}) => {
  const { error, submitFailed } = meta;
  const radioFieldClassNames = classNames('RadioField custom-control custom-radio', className);
  const labelClassNames = classNames('custom-control-label', labelClassName);
  const componentClassNames = classNames('component-container', componentClassName)

  return (
    <div className={containerClassName}>
      {
        options.map((option) => {
          return (
            <div key={option.id} className={radioFieldClassNames}>
              <input
                {...input}
                {...attributes}
                type="radio"
                id={(option.id).replace(/\s/g, '-')}
                className={classNames('custom-control-input', inputClassName)}
                defaultChecked={input.value === option.value}
                value={option.value}
              />
              <label
                className={labelClassNames}
                htmlFor={(option.id).replace(/\s/g, '-')}
              >
                {option.label}
              </label>
              {
                option.component && (
                  <div className={componentClassNames} >
                    { option.component }
                  </div>
                )
              }
            </div>
          );
        })
      }
      {
        (error && submitFailed) && (
          <p className="error text-danger text-small">
            {errorMessage || error}
          </p>
        )
      }
    </div>
  );
};

RadioField.propTypes = {
  containerClassName: PropTypes.string,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })),
  input: PropTypes.object,
  meta: PropTypes.object,
  errorMessage: PropTypes.string,
  labelClassName: PropTypes.string,
  componentClassName: PropTypes.string,
  attributes: PropTypes.object
};

export default RadioField;
